import { render, staticRenderFns } from "./tab-menu.vue?vue&type=template&id=515dd397&scoped=true&"
import script from "./tab-menu.vue?vue&type=script&lang=js&"
export * from "./tab-menu.vue?vue&type=script&lang=js&"
import style0 from "./tab-menu.vue?vue&type=style&index=0&id=515dd397&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515dd397",
  null
  
)

export default component.exports